import {
    type Conversation,
    type ConversationMessage,
    registerCurrentUser,
} from 'api/userSupportAPI';
import { handleError } from 'services/Error';
import { mapConversation, mapMessage, type MappedMessage } from 'services/userSupportHelpers';
import { type AppThunk } from 'store';
import {
    updateConversationMessages,
    updateReferralConversations,
    updateUserProfile,
} from 'store/userSupport/userSupportSlice';

export const registerUser =
    ({ details }: { details: { first_name?: string; last_name?: string } }): AppThunk =>
    async (dispatch) => {
        try {
            const userProfile = await registerCurrentUser({ details });
            dispatch(
                updateUserProfile({
                    upn: userProfile.upn,
                    firstName: userProfile.first_name,
                    lastName: userProfile.last_name,
                }),
            );
        } catch (err) {
            handleError('An error occurred retrieving user details.', err as Error);
        }
    };

export const updateConversations =
    (conversations: Conversation[]): AppThunk =>
    (dispatch) => {
        const mappedConversations = conversations.map(mapConversation);
        const conversationsList = mappedConversations.reduce(
            (prev, curr) => ({ ...prev, [curr.conversationId]: curr }),
            {},
        );
        dispatch(
            updateReferralConversations({
                conversations: conversationsList,
            }),
        );
    };

export interface SocketMessagesPayload {
    conversation_id?: string;
    messages: ConversationMessage[];
}
export const updateMessages =
    (payload: SocketMessagesPayload): AppThunk =>
    (dispatch) => {
        const mappedMessages = payload.messages.map(mapMessage);
        const conversationId = payload.conversation_id;
        const messagesList = mappedMessages.reduce<Record<string, MappedMessage>>(
            (prev, curr) => ({ ...prev, [curr.messageId]: curr }),
            {},
        );
        if (conversationId) {
            dispatch(updateConversationMessages({ conversationId, messages: messagesList }));
        }
    };
